import { Link } from "react-router-dom";
import { useModerationStats } from "@/hooks/useModerationStats";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

const statCards = [
  {
    label: "Needs Review",
    key: "needsHumanReview" as const,
    color: "bg-secondary-container",
    textColor: "text-on-secondary-container",
    link: "/moderation",
  },
  {
    label: "Approved",
    key: "approved" as const,
    color: "bg-primary-container",
    textColor: "text-on-primary-container",
    link: "/experiences",
  },
  {
    label: "Rejected",
    key: "rejected" as const,
    color: "bg-error-container",
    textColor: "text-on-error-container",
    link: "/experiences",
  },
  {
    label: "Escalated",
    key: "escalated" as const,
    color: "bg-tertiary-container",
    textColor: "text-on-tertiary-container",
    link: "/moderation",
  },
];

export function DashboardPage() {
  useDocumentTitle("Dashboard");
  const { data: stats, isLoading, error } = useModerationStats();

  return (
    <div>
      <h1 className="font-headline-lg text-headline-lg text-on-surface mb-stack-md">
        Dashboard
      </h1>

      {isLoading && (
        <p className="font-body-md text-on-surface-variant">Loading stats...</p>
      )}

      {error && (
        <p className="font-body-md text-error">Failed to load moderation stats.</p>
      )}

      {stats && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-stack-md">
          {statCards.map((card) => (
            <Link
              key={card.key}
              to={card.link}
              className={`${card.color} ${card.textColor} rounded-xl p-stack-md hover:opacity-90 transition-opacity`}
            >
              <p className="font-label-sm text-label-sm opacity-80">{card.label}</p>
              <p className="font-headline-lg text-headline-lg font-bold mt-1">
                {stats[card.key]}
              </p>
            </Link>
          ))}
        </div>
      )}

      <div className="mt-stack-lg">
        <h2 className="font-headline-md text-headline-md text-on-surface mb-stack-sm">
          Quick Actions
        </h2>
        <div className="flex flex-wrap gap-stack-sm">
          <Link
            to="/moderation"
            className="px-4 py-2 bg-primary-container text-on-primary-container rounded-lg font-body-md hover:opacity-90 transition-opacity"
          >
            Review Queue
          </Link>
          <Link
            to="/company-suggestions"
            className="px-4 py-2 bg-surface-container-high text-on-surface rounded-lg font-body-md hover:bg-surface-container-highest transition-colors"
          >
            Company Suggestions
          </Link>
          <Link
            to="/experiences"
            className="px-4 py-2 bg-surface-container-high text-on-surface rounded-lg font-body-md hover:bg-surface-container-highest transition-colors"
          >
            Browse Experiences
          </Link>
        </div>
      </div>
    </div>
  );
}
